export const HELP_DOMAIN = 'https://www.bodeswell.io';
export const ENABLE_SHARING = true;
export const PRODUCT_NAME = 'PlanAhead';
export const BUDGETS_APP_NAME = 'SpendSmart™';
export const PRIVACY_POLICY = 'https://www.bodeswell.io/privacy-policy';
export const TERMS_AND_CONDITIONS = 'https://www.bodeswell.io/terms-conditions';
export const SPENDSMART_TERMS_AND_CONDITIONS =
    'https://www.americanexpress.com/content/dam/amex/en-us/banking/wealth/financial_tools_terms_and_conditions.pdf';
export const DATA_CONNECTION_TERMS_AND_CONDITIONS =
    'https://www.americanexpress.com/content/dam/amex/en-us/banking/wealth/data_connection_terms_and_conditions.pdf';
export const AMEX_PRIVACY_CENTER = 'https://www.americanexpress.com/us/privacy-center/index.html';
export const PLAID_USER_TERMS = 'https://plaid.com/legal/#consumers';
export const SHOW_MENTORS = true;
export const AFTER_DELETE = 'https://www.bodeswell.io/delete-account/';
export const ZILLOW_INTEGRATION = false;
export const PIECHART_COLORS = ['#58B8BE', '#A4C95E', '#7E4C95', '#FFA726', '#006F9E'];
export const DEFAULT_INCOME_GROWTH = 0.013; // 1.3%
export const VISIBLE_ACHIEVEMENTS = true;
export const FREECASH_VISIBLE = true;
export const COLLEGE_FUNDING_PICKER = true;
// timeline constants
export const TIMELINE_SCREEN_PORTION = 0.6;
export const TOP_LEGEND_OFFSET = 102;
export const ZOOM_SELECT_OFFSET = 32;
export const TOP_MAX_TEXT_OFFSET = 86;
export const BOTTOM_MAX_TEXT_OFFSET = 54;
export const TIMELINE_LEGEND_FONT = "'Helvetica Neue', Helvetica, sans-serif";
export const TIMELINE_FONT_SIZE_SMALL = 11;
export const TIMELINE_FONT_SIZE_LARGE = 14;
export const SPENDSMART_TERMS_ACCEPTED_COOKIE_NAME = 'spendSmartTermsAccepted';
